export const LOADSTATUS = {
  NONE: 'NONE',
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  ERROR: 'ERROR'
} as const

export type loadStatusType = keyof typeof LOADSTATUS
